<div class="transport-row">
  @for (transport of transports; track transport) {
    <div class="transport" (click)="selectTransport(transport.transportId)">
      <app-transport-item [scale]="scale" [offsetBefore]="offsetBefore" [transport]="transport" [selected]="transport.transportId === selectedTransportId"></app-transport-item>
    </div>
  }
</div>